import { render, staticRenderFns } from "./mapBrandDetails.vue?vue&type=template&id=be0f6f8e&scoped=true&"
import script from "./mapBrandDetails.vue?vue&type=script&lang=js&"
export * from "./mapBrandDetails.vue?vue&type=script&lang=js&"
import style0 from "./mapBrandDetails.vue?vue&type=style&index=0&id=be0f6f8e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0f6f8e",
  null
  
)

export default component.exports